import { initialSessionState, SessionState } from "./SessionState";
import { initialUserState, UserState } from "./UserState";
import { PhaseType } from "../../models/PhaseType";
import { FamiliyMemberType } from "../../models/FamiliyMemberType";
import { MoodboardType } from "../../models/MoodboardType";
import { IngredientType } from "../../models/IngredientType";
import { ActivityType } from "../../models/ActivityType";
import { PlaygroundType } from "../../models/PlaygroundType";

export type SpeeltuinchefState = {
  session: SessionState;
  user: UserState;
  phases: null | Array<PhaseType>;
  families: null | Array<FamiliyMemberType>;
  moodboards: null | Array<MoodboardType>;
  ingredients: null | Array<IngredientType>;
  activities: null | Array<ActivityType>;
  playgrounds: null | Array<PlaygroundType>;
};

const initialState: SpeeltuinchefState = {
  session: initialSessionState,
  user: initialUserState,
  phases: null,
  families: null,
  moodboards: null,
  ingredients: null,
  activities: null,
  playgrounds: null,
};

export { initialState };
